import { debounce } from "lodash";

function updateVideoSizeToCoverParent() {
  const video = document.querySelector(".video__content");

  if (!video) return;

  const videoContainer = document.querySelector(".video");
  let videoRect = video.getBoundingClientRect();
  let videoContainerRect = videoContainer.getBoundingClientRect();
  const videoScaleFactor = 1.2;
  const aspectRatio = 16 / 9;

  if (videoRect.height < videoContainerRect.height) {
    video.style.height = videoContainer.clientHeight * videoScaleFactor + "px";
    video.style.width = videoContainer.clientHeight * videoScaleFactor * aspectRatio + "px";
  } else if (videoRect.width < videoContainerRect.width) {
    video.style.width = videoContainer.clientWidth * videoScaleFactor + "px";
    video.style.height = videoContainer.clientWidth * videoScaleFactor / aspectRatio + "px";
  }
}

const getScript = url => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.src = url
  script.async = true

  script.onerror = reject

  script.onload = script.onreadystatechange = function() {
    const loadState = this.readyState

    if (loadState && loadState !== 'loaded' && loadState !== 'complete') return

    script.onload = script.onreadystatechange = null

    resolve()
  }

  document.head.appendChild(script)
});

updateVideoSizeToCoverParent();

window.addEventListener("resize",
  debounce(updateVideoSizeToCoverParent, 30)
);

let YTPlayerRef;
let YTPlayerCurrStatus;

function attachYTJSAPItoIframe() {
  window.YT.ready(function() {
    new window.YT.Player("player", {
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange
      }
    });
  });

  function onPlayerReady(event) {
    event.target.playVideo();
    YTPlayerRef = event.target;
  }

  function onPlayerStateChange(event) {
    let videoStatuses = Object.entries(window.YT.PlayerState);
    YTPlayerCurrStatus = videoStatuses.find(status => status[1] === event.data)[0];

    const placeholder = document.querySelector(".video__no-video-placeholder");

    if (YTPlayerCurrStatus === "PLAYING") {
      placeholder.classList.add("video__no-video-placeholder_hidden");
    } else {
      placeholder.classList.remove("video__no-video-placeholder_hidden");
    }
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  getScript("https://www.youtube.com/iframe_api").then(()=>attachYTJSAPItoIframe());
});
